export default "__VITE_PUBLIC_ASSET__5da12dc7__"